import { Fragment } from "react";
import { editaSocio, criarSocio } from "../../../../api/Cadastro";
import CampoTexto from "../../../Campos/CampoTexto";
import CampoNumber from "../../../Campos/CampoNumber";
import CampoSimNao from "../../../Campos/CampoSimNao";
import TextField from "@mui/material/TextField";
import InputMask from "react-input-mask";
import Seletor from "../../../Seletor";
import Subtitulo from "../../../Textos/Subtitulo";
import { Box, Grid, Skeleton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import useStyle from "../styles";

import CustomGrid from "../../../GridCadastroCustom";
import IconButtonCustom from "../../../Botoes/IconButtonCustom";
import AddIcon from "@mui/icons-material/Add";
import IconButtonDelete from "../../../Botoes/IconButtonDelete";
import { PositionTooltip, TooltipInformacao } from "../../../TooltipInformacao";
import EnderecoPrincipal from "../../EnderecoPrincipal";
import Arquivo from "../../Arquivo";
import theme from "../../../Paleta/theme";

export default function SocioForm({
  fieldErrors,
  socios,
  setSocios,
  identificaItem,
  isLoading,
  title,
  tooltipAdd,
  tooltipDelete,
  idPerfilLimiteOperacional,
  idCliente,
  frontendErrors = { socios: {} },
  onClearError,
  onClearEnderecoError,
}) {
  const getEnderecoError = (index, campo) => {
    if (frontendErrors?.socios?.[index]?.[campo]) {
      return frontendErrors.socios[index][campo];
    }
    return "";
  };

  const hasEnderecoError = (index, campo) => {
    return !!frontendErrors?.socios?.[index]?.[campo];
  };

  // Função para obter erro de um campo (combina API + frontend)
  const getFieldError = (index, propriedade) => {
    // Prioriza erro da API se existir
    if (fieldErrors && fieldErrors[propriedade]) {
      return fieldErrors[propriedade];
    }
    // Senão, usa erro de frontend
    if (frontendErrors?.socios?.[index]?.[propriedade]) {
      return frontendErrors.socios[index][propriedade];
    }
    return "";
  };

  const hasError = (index, propriedade) => {
    return (
      !!(fieldErrors && fieldErrors[propriedade]) ||
      !!frontendErrors?.socios?.[index]?.[propriedade]
    );
  };

  const classes = useStyle();
  const handlerChangeValue = (e, index) => {
    let dados = socios;
    dados[index].campos = dados[index]?.campos?.map((c) => {
      if (e.target.name === c.propriedade) c.valor = e.target.value;
      return c;
    });

    setSocios(() => [...dados]);

    if (onClearError && frontendErrors?.socios?.[index]?.[e.target.name]) {
      onClearError(index, e.target.name);
    }
  };

  const handleChangeCheck = (e, index) => {
    let dados = socios;
    dados[index].campos = dados[index]?.campos?.map((c) => {
      if (e.target.name === c.propriedade) c.valor = e.target.value;
      return c;
    });

    setSocios(() => [...dados]);
  };

  const handleChangeCheckAssinaturaContrato = (e, index) => {
    let dados = socios;
    dados[index].assinaturaContratoSocio.assinaContrato.valor = e.target.value; // Mude para e.target.value
    setSocios(() => [...dados]);
  };

  const handlerChangeValueAssinaturaContrato = (e, index) => {
    let dados = socios;

    const camposAssinatura = dados[
      index
    ]?.assinaturaContratoSocio?.camposAssinatura?.map((c) => {
      if (e.target.name === c.propriedade) c.valor = e.target.value;
      return c;
    });

    dados[index].assinaturaContratoSocio.camposAssinatura = camposAssinatura;
    setSocios(() => [...dados]);
  };

  const handlerChangeSelect = async (name, value, index) => {
    let dados = socios;
    dados[index][name] = value;

    if (
      name === "idNacionalidade" ||
      name === "idTipoEstadoCivil" ||
      name === "idTipoSocio" ||
      name === "idTipoCliente"
    ) {
      const resp = await editaSocio(
        dados[index].idCliente,
        idPerfilLimiteOperacional,
        dados[index]
      );

      dados[index] = resp;
    }

    setSocios(() => [...dados]);
  };

  const handlerChangeSelectCampo = async (name, value, index, indexCampo) => {
    let dados = socios;
    dados[index][name] = value;
    dados[index].campos[indexCampo].selecedID = value;
    if (
      name === "idNacionalidade" ||
      name === "idTipoEstadoCivil" ||
      name === "idTipoSocio" ||
      name === "idTipoCliente"
    ) {
      const resp = await editaSocio(
        dados[index].idCliente,
        idPerfilLimiteOperacional,
        dados[index]
      );

      dados[index] = resp;
    }

    setSocios(() => [...dados]);
  };

  const handlerChangeValuePercentual = (value, propriedade, index) => {
    let dados = socios;
    dados[index].campos = dados[index]?.campos?.map((c) => {
      if (propriedade === c.propriedade) c.valor = value;
      return c;
    });

    setSocios(() => [...dados]);
  };

  const handlerAddCampos = async () => {
    try {
      let dados = socios;

      const resp = await criarSocio(idCliente, idPerfilLimiteOperacional);

      dados.push(resp);

      setSocios(() => [...dados]);

      setTimeout(() => {
        var tamanhoPagina = document.body.scrollHeight;
        window.scrollTo(0, tamanhoPagina + 30);
      }, 200);
    } catch (error) {}
  };

  const handlerRemoveCampos = (index) => {
    setSocios((prevState) => {
      return prevState.filter((_, i) => i !== index);
    });
  };

  const handlerChangeEndereco = (enderecoNew, index) => {
    let dados = socios;
    dados[index].endereco = enderecoNew;
    setSocios(() => [...dados]);

    // Verifica se algum campo de endereço foi preenchido e limpa o erro correspondente
    if (onClearEnderecoError) {
      const camposEndereco = [
        "cep",
        "logradouro",
        "numero",
        "bairro",
        "cidade",
        "idUf",
      ];
      camposEndereco.forEach((campo) => {
        if (
          enderecoNew[campo] &&
          enderecoNew[campo].toString().trim() !== "" &&
          frontendErrors?.socios?.[index]?.[campo]
        ) {
          onClearEnderecoError(index, campo);
        }
      });
    }
  };

  const handlerChangeDocumento = (documentosNew, index) => {
    let dados = socios;
    dados[index].documentos = documentosNew;
    setSocios(() => [...dados]);
  };

  return (
    <>
      <div className={classes.box}>
        {isLoading ? (
          <Skeleton animation="wave" width={"10%"} height={30} sx={{ mb: 2 }} />
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Subtitulo color="primary" label={title} />
            <IconButtonCustom onClick={handlerAddCampos}>
              <TooltipInformacao
                positionStart={PositionTooltip.left}
                descricao={tooltipAdd}
              >
                <AddIcon sx={{ fontSize: "1.2rem" }} color="inherit" />
              </TooltipInformacao>
            </IconButtonCustom>
          </Box>
        )}

        <Grid
          container
          rowSpacing={1}
          sx={{ alignItems: "center" }}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          {!!socios?.length &&
            socios?.map((dado, index) => (
              <Fragment id={`socio-${index}`} key={`dadosForm${index}`}>
                <div
                  style={{
                    height: 1,
                    backgroundColor: theme.palette.secondary.light,
                    width: "100%",
                    opacity: 0.3,
                    marginBottom: 10,
                    marginLeft: 25,
                    marginTop: 10,
                  }}
                />
                <Grid item xs={12} md={12} sx={index > 0 ? { mt: 0 } : {}}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <Subtitulo
                      color="secondary"
                      sx={{}}
                      label={`${index + 1}º  ${identificaItem}`}
                    />
                    {frontendErrors?.socios?.[index] &&
                      Object.keys(frontendErrors.socios[index]).length > 0 && (
                        <Box
                          sx={{
                            color: "error.main",
                            ml: 1,
                            fontSize: "0.8rem",
                          }}
                        >
                          (campos obrigatórios)
                        </Box>
                      )}

                    {socios.length > 1 && index > 0 && (
                      <TooltipInformacao
                        positionStart={PositionTooltip.right}
                        descricao={tooltipDelete}
                      >
                        <>
                          {dado.idSocio <= 0 && (
                            <IconButtonDelete
                              sx={{ mt: -2 }}
                              onClick={() => handlerRemoveCampos(index)}
                            />
                          )}
                        </>
                      </TooltipInformacao>
                    )}
                  </Box>
                </Grid>

                {dado?.campos &&
                  dado?.campos?.map(
                    (c, i, array) =>
                      //c.enable &&
                      c.propriedade !== "Cep" && (
                        <Fragment key={`campos${i}`}>
                          <CustomGrid index={i} array={array} md={6}>
                            {c.tipoControle === "Selecao" &&
                              c.propriedade === "IDNacionalidade" && (
                                <Seletor
                                  isLoading={isLoading}
                                  setSelect={(e) => {
                                    handlerChangeSelectCampo(
                                      "idNacionalidade",
                                      e,
                                      index,
                                      i
                                    );
                                  }}
                                  required={c.obrigatorio}
                                  sx={{ mt: 1 }}
                                  // error={!!fieldErrors[c.propriedade]}
                                  // helperText={fieldErrors[c.propriedade] || ""}
                                  label={c.label}
                                  list={dado.nacionalidades}
                                  size="medium"
                                  key={"nacionalidades"}
                                  fullWidth={true}
                                  value={dado?.idNacionalidade}
                                />
                              )}
                            {c.tipoControle === "Selecao" &&
                              c.propriedade === "IDTipoClienteSocio" && (
                                <Seletor
                                  isLoading={isLoading}
                                  setSelect={(e) =>
                                    handlerChangeSelectCampo(
                                      "idTipoSocio",
                                      e,
                                      index,
                                      i
                                    )
                                  }
                                  sx={{ mt: 1 }}
                                  // error={!!fieldErrors[c.propriedade]}
                                  // helperText={fieldErrors[c.propriedade] || ""}
                                  list={dado.tiposSocios}
                                  size="medium"
                                  key={"tipoSocio"}
                                  label={c.label}
                                  fullWidth={true}
                                  value={dado?.idTipoSocio}
                                  disabled={!c.enable}
                                />
                              )}

                            {c.tipoControle === "Selecao" &&
                              c.propriedade === "IDTipoCliente" && (
                                <Seletor
                                  required={c.obrigatorio}
                                  isLoading={isLoading}
                                  setSelect={(e) =>
                                    handlerChangeSelectCampo(
                                      "idTipoCliente",
                                      e,
                                      index,
                                      i
                                    )
                                  }
                                  // error={!!fieldErrors[c.propriedade]}
                                  // helperText={fieldErrors[c.propriedade] || ""}
                                  sx={{ mt: 1 }}
                                  list={dado.tiposClientes}
                                  size="medium"
                                  key={"tiposClientes"}
                                  label={c.label}
                                  fullWidth={true}
                                  value={dado?.idTipoCliente}
                                />
                              )}

                            {c.tipoMascara === "CPF" &&
                              (isLoading ? (
                                <Skeleton
                                  animation="wave"
                                  width={"100%"}
                                  height={60}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <InputMask
                                    onChange={(e) =>
                                      handlerChangeValue(e, index)
                                    }
                                    mask={"999.999.999-99"}
                                    value={c.valor}
                                    enable={c.enable}
                                    maskChar="_"
                                  >
                                    {({ value, onChange }) => (
                                      <TextField
                                        spellCheck="false"
                                        margin="normal"
                                        required={c.obrigatorio}
                                        // error={!!fieldErrors[c.propriedade]}
                                        // helperText={
                                        //   fieldErrors[c.propriedade] || ""
                                        // }
                                        fullWidth={true}
                                        label={c.label}
                                        maxLength={c.maxLength}
                                        name={c.propriedade}
                                        value={value}
                                        size="medium"
                                        autoFocus
                                        onChange={onChange}
                                      />
                                    )}
                                  </InputMask>
                                  {c.informacao && (
                                    <Tooltip title={c.informacao}>
                                      <IconButton>
                                        <InfoIcon
                                          fontSize="small"
                                          color="primary"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              ))}

                            {c.tipoMascara === "CNPJ" &&
                              (isLoading ? (
                                <Skeleton
                                  animation="wave"
                                  width={"100%"}
                                  height={60}
                                />
                              ) : (
                                <>
                                  <InputMask
                                    onChange={(e) =>
                                      handlerChangeValue(e, index)
                                    }
                                    mask={"99.999.999/9999-99"}
                                    value={c.valor}
                                    enable={c.enable}
                                    maskChar="_"
                                  >
                                    {({ value, onChange }) => (
                                      <TextField
                                        spellCheck="false"
                                        margin="normal"
                                        required={c.obrigatorio}
                                        // error={!!fieldErrors[c.propriedade]}
                                        // helperText={
                                        //   fieldErrors[c.propriedade] || ""
                                        // }
                                        fullWidth={true}
                                        label={c.label}
                                        maxLength={c.maxLength}
                                        name={c.propriedade}
                                        value={value}
                                        size="medium"
                                        autoFocus
                                        onChange={onChange}
                                      />
                                    )}
                                  </InputMask>
                                </>
                              ))}

                            {c.tipoControle === "Texto" &&
                              c.tipoMascara.length === 0 &&
                              (isLoading ? (
                                <Grid sx={{ mt: 1 }}>
                                  <Skeleton
                                    animation="wave"
                                    width={"100%"}
                                    height={60}
                                  />
                                </Grid>
                              ) : (
                                <Grid sx={{ mt: 1 }}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <CampoTexto
                                      enable={c.enable}
                                      variant="filled"
                                      size="medium"
                                      fullWidth={true}
                                      value={c.valor}
                                      error={hasError(index, c.propriedade)}
                                      helperText={getFieldError(
                                        index,
                                        c.propriedade
                                      )}
                                      defaultValue=" "
                                      label={c.label}
                                      name={c.propriedade}
                                      handlerChange={(e) =>
                                        handlerChangeValue(e, index)
                                      }
                                      maximoDigitos={c.maxLength}
                                      required={c.obrigatorio}
                                    />
                                    {c.informacao && (
                                      <Tooltip title={c.informacao}>
                                        <IconButton>
                                          <InfoIcon
                                            fontSize="small"
                                            color="primary"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                </Grid>
                              ))}

                            {c.tipoControle === "Check" &&
                              (isLoading ? (
                                <Skeleton
                                  animation="wave"
                                  width={"100%"}
                                  height={60}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <CampoSimNao
                                    key={`simnao_${i}`}
                                    name={c.propriedade}
                                    value={c.valor}
                                    handleChange={(e) =>
                                      handleChangeCheck(e, index)
                                    }
                                    descricao={c.label}
                                    enable={c.enable}
                                    required={c.obrigatorio}
                                    fullWidth={true}
                                  />
                                  {c.informacao && (
                                    <Tooltip title={c.informacao}>
                                      <IconButton>
                                        <InfoIcon
                                          fontSize="small"
                                          color="primary"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              ))}

                            {c.tipoControle === "Numero" && (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt: 1,
                                }}
                              >
                                <CampoNumber
                                  isLoading={isLoading}
                                  isMonetario={c.tipoMascara === "Monetaria"}
                                  isPercent={
                                    c.tipoMascara === "percentual" ||
                                    c.propriedade === "PercentualCapital"
                                  }
                                  variant="outlined"
                                  size="medium"
                                  enable={c.enable}
                                  fullWidth={true}
                                  label={c.label}
                                  error={hasError(index, c.propriedade)}
                                  helperText={getFieldError(
                                    index,
                                    c.propriedade
                                  )}
                                  name={c.propriedade}
                                  value={c.valor}
                                  onChange={(value, propriedade) =>
                                    handlerChangeValuePercentual(
                                      value,
                                      propriedade,
                                      index
                                    )
                                  }
                                  className={classes.campo}
                                  maximoDigitos={c.maxLength}
                                  required={c.obrigatorio}
                                />
                                {c.informacao && (
                                  <Tooltip title={c.informacao}>
                                    <IconButton>
                                      <InfoIcon
                                        fontSize="small"
                                        color="primary"
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Box>
                            )}
                          </CustomGrid>
                        </Fragment>
                      )
                  )}

                {dado?.enableTipoEstadoCivil && dado?.idTipoEstadoCivil > 0 && (
                  <Grid item xs={6} md={6}>
                    <Seletor
                      isLoading={isLoading}
                      setSelect={(e) =>
                        handlerChangeSelect("idTipoEstadoCivil", e, index)
                      }
                      required={dado.obrigatorio}
                      sx={{ mt: 2 }}
                      list={dado.tiposEstadoCivil}
                      size="medium"
                      error={hasError(index, dado.propriedade)}
                      helperText={getFieldError(index, dado.propriedade)}
                      key={"tipoEstadoCivil"}
                      label="Tipo Estado Civil"
                      fullWidth={true}
                      value={dado?.idTipoEstadoCivil}
                    />
                  </Grid>
                )}

                {dado?.assinaturaContratoSocio?.habilitarAssinaturaContrato && (
                  <Fragment>
                    <Grid item xs={12} md={12}>
                      <Box mt={3}>
                        <Subtitulo sx={{ mb: 2, fontSize: 15, color: "#000" }}>
                          Dados da assinatura de contrato
                        </Subtitulo>
                        {isLoading ? (
                          <Skeleton
                            animation="wave"
                            width={"100%"}
                            height={60}
                          />
                        ) : (
                          <CampoSimNao
                            name={dado?.assinaturaContratoSocio?.assinaContrato?.propriedade}
                            value={dado?.assinaturaContratoSocio?.assinaContrato?.valor}
                            handleChange={(e) => handleChangeCheckAssinaturaContrato(e, index)}
                            descricao={dado?.assinaturaContratoSocio?.assinaContrato?.label}
                            enable={true}
                            required={false}
                            fullWidth={false}
                          />
                        )}
                      </Box>
                    </Grid>

                    {dado?.assinaturaContratoSocio?.assinaContrato?.valor &&
                      dado?.assinaturaContratoSocio?.camposAssinatura &&
                      dado?.assinaturaContratoSocio?.camposAssinatura?.map(
                        (c, i, array) =>
                          c.enable && (
                            <Fragment key={`campos-assinatura-contrato-${i}`}>
                              {c.tipoControle === "Texto" &&
                                c.tipoMascara.length === 0 &&
                                (isLoading ? (
                                  <CustomGrid index={i} array={array} md={6}>
                                    <Skeleton
                                      animation="wave"
                                      width={"100%"}
                                      height={60}
                                    />
                                  </CustomGrid>
                                ) : (
                                  <CustomGrid index={i} array={array} md={6}>
                                    <CampoTexto
                                      enable={c.enable}
                                      variant="filled"
                                      size="medium"
                                      fullWidth={true}
                                      error={hasError(index, c.propriedade)}
                                      helperText={getFieldError(
                                        index,
                                        c.propriedade
                                      )}
                                      value={c.valor}
                                      defaultValue=" "
                                      label={c.label}
                                      name={c.propriedade}
                                      handlerChange={(e) =>
                                        handlerChangeValueAssinaturaContrato(
                                          e,
                                          index
                                        )
                                      }
                                      className={classes.campo}
                                      maximoDigitos={c.maxLength}
                                      required={c.obrigatorio}
                                    />
                                  </CustomGrid>
                                ))}
                            </Fragment>
                          )
                      )}
                  </Fragment>
                )}

                <Box mt={3}>
                  <EnderecoPrincipal
                    setData={(e) => handlerChangeEndereco(e, index)}
                    isLoading={false}
                    user={null}
                    enderecoDefaultValue={dado?.endereco}
                    habilitarEnderecoExterior={true}
                    validationErrors={{
                      cep: getEnderecoError(index, "cep"),
                      logradouro: getEnderecoError(index, "logradouro"),
                      numero: getEnderecoError(index, "numero"),
                      bairro: getEnderecoError(index, "bairro"),
                      cidade: getEnderecoError(index, "cidade"),
                      idUf: getEnderecoError(index, "idUf"),
                    }}
                    hasValidationError={(campo) =>
                      hasEnderecoError(index, campo)
                    }
                    entityType="socio"
                    entityIndex={index}
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  {dado?.documentos && dado?.documentos.length > 0 && (
                    <Arquivo
                      key={`docs-socio-${index}-${dado.idTipoCliente}`}
                      setDados={(e) => handlerChangeDocumento(e, index)}
                      items={dado?.documentos}
                    />
                  )}
                </Box>
                {/* </div> */}
              </Fragment>
            ))}
        </Grid>
      </div>
    </>
  );
}